// import React from 'react';
// import { Link } from 'react-router-dom';

// interface TrendProduct {
//   img: string;
//   title: string;
//   price: string;
//   delay: string;
// }

// const trendProducts: TrendProduct[] = [
//   { img: '/assets/img/products2/product-1-1.png', title: 'Flower Pendant', price: '₹355.00', delay: '0.2s' },
//   { img: '/assets/img/products2/product-1-2.png', title: 'Wedding Ring', price: '₹355.00', delay: '0.3s' },
//   { img: '/assets/img/products2/product-1-3.png', title: 'Multi Stone Set', price: '₹250.00', delay: '0.4s' },
//   { img: '/assets/img/products2/product-1-4.png', title: 'Designer Chain', price: '₹155.00', delay: '0.5s' },
// ];

// const WishlistIcon: React.FC = () => (
//   <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <path d="M11.62 18.8101C11.28 18.9301 10.72 18.9301 10.38 18.8101C7.48 17.8201 1 13.6901 1 6.6901C1 3.6001 3.49 1.1001 6.56 1.1001C8.38 1.1001 9.99 1.9801 11 3.3401C12.01 1.9801 13.63 1.1001 15.44 1.1001C18.51 1.1001 21 3.6001 21 6.6901C21 13.6901 14.52 17.8201 11.62 18.8101Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
//   </svg>
// );

// const EyeIcon: React.FC = () => (
//   <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <path d="M14.5799 9.99992C14.5799 11.9799 12.9799 13.5799 10.9999 13.5799C9.01992 13.5799 7.41992 11.9799 7.41992 9.99992C7.41992 8.01992 9.01992 6.41992 10.9999 6.41992C12.9799 6.41992 14.5799 8.01992 14.5799 9.99992Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
//     <path d="M11.0001 18.27C14.5301 18.27 17.8201 16.19 20.1101 12.59C21.0101 11.18 21.0101 8.80997 20.1101 7.39997C17.8201 3.79997 14.5301 1.71997 11.0001 1.71997C7.47009 1.71997 4.18009 3.79997 1.89009 7.39997C0.990088 8.80997 0.990088 11.18 1.89009 12.59C4.18009 16.19 7.47009 18.27 11.0001 18.27Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
//   </svg>
// );

// const ProductSection2: React.FC = () => {
//   return (
//     <section className="section-layout2 space space-extra-bottom z-index-common">
//       <img src="/assets/img/shapes/ele-p-1-1.svg" alt="elements" className="ele1" />
//       <img src="/assets/img/shapes/ele-p-1-2.svg" alt="elements" className="ele2" />
//       <img src="/assets/img/shapes/ele-p-1-3.svg" alt="elements" className="ele3" />
//       <img src="/assets/img/shapes/ele-p-1-4.svg" alt="elements" className="ele4" />
//       <div className="container">
//         <div className="row">
//           <div className="col-lg-auto mx-auto">
//             <div className="title-area text-center">
//               <span className="sec-subtitle">exclusive collection</span>
//               <h2 className="sec-title text-white">top Trending Products</h2>
//               <img src="/assets/img/shapes/title-shape-1.svg" alt="title shape" />
//             </div>
//           </div>
//         </div>
//         <div className="row">
//           <div className="col-lg-4 wow animate__fadeInUp" data-wow-delay="0.1s">
//             <div
//               className="img-box2"
//               style={{ backgroundImage: "url('/assets/img/products2/product-img-1.jpg')" }}
//             >
//               <div className="img-body">
//                 <img src="/assets/img/products2/product-ele-1.svg" alt="shape" className="ele1" />
//                 <span className="img-caption">15% off</span>
//               </div>
//             </div>
//           </div>
//           <div className="col-lg-8">
//             <div className="row gx-20">
//               {trendProducts.map((product, i) => (
//                 <div key={i} className="col-md-6 wow animate__fadeInUp" data-wow-delay={product.delay}>
//                   <div className="product-style2">
//                     <div className="product-action">
//                       <button className="product-action__btn"><WishlistIcon /></button>
//                       <button className="product-action__btn"><EyeIcon /></button>
//                     </div>
//                     <img src="/assets/img/products2/product-ele-2.svg" alt="product" className="ele1" />
//                     <div className="product-img">
//                       <img className="img" src={product.img} alt="product" />
//                     </div>
//                     <h3 className="product-title">
//                       <Link to="/shop-details">{product.title}</Link>
//                     </h3>
//                     <span className="product-price">
//                       <span className="product-price__number">{product.price}</span>
//                       <Link className="product-cart" to="/cart">add to cart</Link>
//                     </span>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default ProductSection2;






import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getHomeTrendingProducts } from "../pages/publicservice/productService";
import { Product, ProductImage } from "../pages/publicservice/interface/types";



const WishlistIcon: React.FC = () => (
  <svg
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
  >
    <path
      d="M11.62 18.8101C11.28 18.9301 10.72 18.9301 10.38 18.8101C7.48 17.8201 1 13.6901 1 6.6901C1 3.6001 3.49 1.1001 6.56 1.1001C8.38 1.1001 9.99 1.9801 11 3.3401C12.01 1.9801 13.63 1.1001 15.44 1.1001C18.51 1.1001 21 3.6001 21 6.6901C21 13.6901 14.52 17.8201 11.62 18.8101Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const EyeIcon: React.FC = () => (
  <svg
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
  >
    <path
      d="M14.5799 9.99992C14.5799 11.9799 12.9799 13.5799 10.9999 13.5799C9.01992 13.5799 7.41992 11.9799 7.41992 9.99992C7.41992 8.01992 9.01992 6.41992 10.9999 6.41992C12.9799 6.41992 14.5799 8.01992 14.5799 9.99992Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0001 18.27C14.5301 18.27 17.8201 16.19 20.1101 12.59C21.0101 11.18 21.0101 8.80997 20.1101 7.39997C17.8201 3.79997 14.5301 1.71997 11.0001 1.71997C7.47009 1.71997 4.18009 3.79997 1.89009 7.39997C0.990088 8.80997 0.990088 11.18 1.89009 12.59C4.18009 16.19 7.47009 18.27 11.0001 18.27Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const API_PATH = process.env.REACT_APP_API_PATH;

const ProductSection2: React.FC = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    getTrendingProducts();
  }, []);

  const getTrendingProducts = async () => {
    try {
      const data = await getHomeTrendingProducts();
      setProducts(data.dataList);
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };

  const getPrimaryImage = (images: ProductImage[]) => {
    const primary =
      images.find((x) => x.isPrimary) || images[0];

    return primary
      ? `${API_PATH}/uploads/${primary.imageURL}`
      : "/assets/img/no-image.png";
  };

  return (
    <section className="section-layout2 space space-extra-bottom z-index-common">
      <img
        src="/assets/img/shapes/ele-p-1-1.svg"
        alt="elements"
        className="ele1"
      />

      <img
        src="/assets/img/shapes/ele-p-1-2.svg"
        alt="elements"
        className="ele2"
      />

      <img
        src="/assets/img/shapes/ele-p-1-3.svg"
        alt="elements"
        className="ele3"
      />

      <img
        src="/assets/img/shapes/ele-p-1-4.svg"
        alt="elements"
        className="ele4"
      />

      <div className="container">
        {/* TITLE */}
        <div className="row">
          <div className="col-lg-auto mx-auto">
            <div className="title-area text-center">
              <span className="sec-subtitle">
                exclusive collection
              </span>

              <h2 className="sec-title text-white">
                top Trending Products
              </h2>

              <img
                src="/assets/img/shapes/title-shape-1.svg"
                alt="title shape"
              />
            </div>
          </div>
        </div>

        <div className="row">
          {/* LEFT BANNER */}
          <div className="col-lg-4 wow animate__fadeInUp">
            <div
              className="img-box2"
              style={{
                backgroundImage:
                  "url('/assets/img/products2/product-img-1.jpg')",
              }}
            >
              <div className="img-body">
                <img
                  src="/assets/img/products2/product-ele-1.svg"
                  alt="shape"
                  className="ele1"
                />

                <span className="img-caption">
                  15% OFF
                </span>
              </div>
            </div>
          </div>

          {/* PRODUCTS */}
          <div className="col-lg-8">
            <div className="row gx-20">
              {loading ? (
                <div className="col-12 text-center text-white">
                  Loading...
                </div>
              ) : (
                products.map((product, index) => (
                  <div
                    key={product.productID}
                    className="col-md-6 wow animate__fadeInUp"
                    data-wow-delay={`${0.2 + index * 0.1}s`}
                  >
                    <div className="product-style2 custom-product-style2">
                      {/* ACTIONS */}
                      <div className="product-action">
                        <button className="product-action__btn">
                          <WishlistIcon />
                        </button>

                        <button className="product-action__btn">
                          <EyeIcon />
                        </button>
                      </div>

                      <img
                        src="/assets/img/products2/product-ele-2.svg"
                        alt="shape"
                        className="ele1"
                      />

                      {/* IMAGE */}
                      <div className="product-img product-img-product">
                        <img
                          className="img"
                          src={getPrimaryImage(product.images)}
                          alt={product.productName}
                        />
                      </div>

                      {/* CATEGORY */}
                      <span className="product-category">
                        {product.categoryName}
                      </span>

                      {/* TITLE */}
                      <h3 className="product-title custom-product-title">
                        <Link
                          to={`/shop-details/${product.productSlug}`}
                        >
                          {product.productName}
                        </Link>
                      </h3>

                      {/* PRICE */}
                      <div className="product-price">
                        <span className="product-price__number">
                          ₹{product.sellingPrice}
                        </span>

                        <del className="ms-2">
                          ₹{product.mrp}
                        </del>
                      </div>

                      {/* DISCOUNT */}
                      <div className="mt-1 stone-section">
                           <div className="mt-2 small text-muted">
                        {product.brandName} | {product.stoneType}
                         <div className="badge bg-danger mx-3">
                          {product.discountPercent.toFixed(0)}% OFF
                        </div>
                      </div>
                       
                       
                      </div>

                      {/* BRAND / STONE */}
                    

                      {/* CART */}
                      <div className="mt-3">
                        <Link
                          className="product-cart add to card-inproduct"
                          to={`/cart/${product.productID}`}
                        >
                          Add To Cart
                        </Link>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductSection2;